import styled from "styled-components";

export const Container = styled.div`
  color: #fff;
  padding: 32px;
  max-width: 340px;
  border-radius: 10px;
  background-color: #23395d;
  box-shadow: 10px 10px 15px 10px #152238;

  .light-mode {
    color: #000;
    background-color: #fff;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 270px;
  cursor: pointer,
  overflow: hidden;
  position: relative;
  border-radius: 10px;
  display: inline-block;
  background-color: #00ffff !important;

  .imgIcon {
    top: 40%;
    bottom: 0;
    left: 40%;
    order: 1;
    color:#fff;
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    position: absolute;
    justify-content: center;
  transition: all .3s ease-in-out;
  }

  .imgIcon:hover {
    display: block;
    color: #fff;
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  cursor: pointer;
  position: inherit;
  object-fit: cover;
  border-radius: 10px;

  &:hover {
    opacity: 0.5 !important;
    transition: 0.6s;
  }
 
`;



export const Details = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h3`
  cursor: pointer;
  font-weight: 500;
  margin-top: 15px;

  &:hover {
    color: #00ffff;
  }
`;

export const Subtitle = styled.p`
  opacity: 0.5;
  font-size: 14px;
  margin-top: 15px;
`;

export const Option = styled.div`
  display: flex;
  margin-top: 15px;
  align-item: center;
  margin-bottom: 15px;
  justify-content: space-between;
  border-bottom: 0.5px solid gray;
`;

export const Coin = styled.div`
  display: flex;
  align-item: center;
  margin-bottom: 10px;

  span {
    color: #00ffff;
    font-size: 13px;
    margin-left: 5px;
    font-weight: 500;
    letter-spacing: 1px;
  }

  @media (max-width: 350px) {
        display: flex;
        margin-top: 15px;
        margin-bottom: 15px;
        -webkit-box-pack: justify;
        justify-content: space-between;
        flex-direction: column;
        align-items: center;
    }
    
`;

export const Eth = styled.img`
  width: 20px;
  height: 20px;
`;

export const Days = styled.div`
  display: flex;
  align-item: center;
  margin-bottom: 10px;
`;

export const Time = styled.img`
  width: 15px;
  height: 15px;
  opacity: 0.5;
  border-radius: 50%;
`;
export const Countdown = styled.span`
  opacity: 0.5;
  font-size: 13px;
  margin-left: 5px;
`;

// export const Hr = styled.div`
//   width: 100%;
//   opacity: 0.5;
//   margin-top: 5%;
//   margin-bottom: 5%;
//   border: 0.2px solid #fff;
// `;

export const Author = styled.div`
  display: flex;
  margin-top: 15px;
  align-item: center;
`;

export const Profile = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 50%;
`;

export const AuthorName = styled.p`
  // opacity: 0.5;
  text-align: end;
  font-size: 13px;
  margin-left: 10px;

  span {
    color: #fff;
    opacity: 0.9;
    cursor: pointer;

    &:hover {
      color: #00ffff;
    }
  }
`;

export const Toggler = styled.button`
  display: flex;
  position: absolute;
  right: 20px;
  top: 10px;
  width: 35px;
  height: 35px;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.toggleIcon};
  background-color: transparent;
  transition: all ${(props) => props.theme.transitionTime};
  border: none;
  outline: none;
  cursor: pointer;
  @media (max-width: 768px) {
    top: 5px;
    right: 50%;
    transform: translate(50%, 0%);
  }
`;
